import "./Systems.css";
import { useEffect, useState } from "react";
import { getSystemList } from "../../api/system.api";
import { useNavigate } from "react-router-dom";

export default function Systems() {
    const [systems, setSystems] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        getSystemList().then(res => {
            setSystems(res.data.systems || []);
        });
    }, []);

    return (
        <div className="systems-page">
            <h2>Select System</h2>

            <div className="systems-grid">
                {systems.map(sys => (
                    <div
                        key={sys.id}
                        className="system-card"
                        onClick={() => navigate(`/branches/${sys.id}`)}
                    >
                        {sys.name}
                    </div>
                ))}
            </div>
        </div>
    );
}
